var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ErrorPageTemplate',{attrs:{"errorCode":_vm.errorCode,"errorDescription":_vm.errorDescription}})
}
var staticRenderFns = []

export { render, staticRenderFns }